import { z, ZodType } from 'zod';

export type Promocode = {
	id: number;
	code: string;
	currency: string;
	currentDeposit: number;
	currentWagering: number;
	totalDeposit: number;
	totalWagering: number;
	status: string;
};

export const promocodeSchema: ZodType<Promocode> = z.object({
	id: z.number(),
	code: z.string(),
	currency: z.string(),
	currentDeposit: z.number(),
	currentWagering: z.number(),
	totalDeposit: z.number(),
	totalWagering: z.number(),
	status: z.string(),
});
